export default (state=false, action) => {
	switch(action.type){
		case 'STATE_CHANGE':
			return action.connected;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/online.js